import { caseListContainerClasses, caseListContainerWrapperClasses } from '../../components/common/caseListClasses';
import { useTemplateContext } from './context/TemplateContext';
import TemplateFormattingSettingModal from './modals/TemplateFormattingSettingModal';
import TemplateModal from './modals/TemplateModal';
import DemandTypeFilter from '../../components/ui-control/DemandTypeFilter';
import TemplateListPagination from '../../components/ui-control/TemplateListPagination';
import { sectionTitleClasses } from '../../components/common/formClasses';
import ListTable from '../../components/common/ListTable';
import TemplateRow from './components/DemandTemplateRow';
import DemandTemplateCards from './components/DemandTemplateCards';
import DemandTypeNameModal from './modals/DemandTypeNameModal';

const HEADERS = [
    { label: 'Demand Type' },
    { label: 'Case Type' },
    { label: 'State' },
    { label: 'Template' },
];

const TemplateList = () => {
    const {
        templateListData,
        isShowTemplateList,
        templateFormattingModalOpen,
        demandTypeNameModalOpen,
        getTemplateListIsLoading,
    } = useTemplateContext();

    return (
        <>
            {isShowTemplateList && <section>
                <div className={`${caseListContainerWrapperClasses} ${caseListContainerClasses}`}>
                    <div className='listing template-listing'>
                        <h2 className={`mb-10! ${sectionTitleClasses}`}>Templates</h2>
                        <DemandTemplateCards />
                        <DemandTypeFilter />

                        <ListTable headers={HEADERS} isLoading={getTemplateListIsLoading}>
                            {templateListData?.map((item, i) => (
                                <TemplateRow key={i} item={item} />
                            ))}
                        </ListTable>
                        <TemplateListPagination />

                        <TemplateModal />
                    </div>
                </div>
            </section>}
            {templateFormattingModalOpen && <TemplateFormattingSettingModal />}

            {demandTypeNameModalOpen && <DemandTypeNameModal />}
        </>
    );
};

export default TemplateList;
